export function getAssociationColumnVisibility(typeConfig, entities = []) {
	return {
		code: !typeConfig.IsCodeSystemManaged,
		externalKey: !typeConfig.IsExternalKeySystemManaged
			&& entities.some(entity => !!entity.ExternalKey)
	};
}
